import { AsyncAutocompleteFieldType, HookAutocompleteField } from 'components/shared/dropdowns'
import { useAccountsTypeaheadWithTypesQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

export const AccountField: React.FC<AsyncAutocompleteFieldType> = props => {
  return (
    <HookAutocompleteField
      useQuery={useAccountsTypeaheadWithTypesQuery}
      transform={data =>
        data.accountsTypeahead.map(elem => {
          const differentiator =
            elem.type === 'individual'
              ? (elem.email && ` <${elem.email}>`) || ''
              : (elem.client_type && ` <${elem.client_type}>`) || ''

          return { label: elem.name + differentiator, value: elem.id }
        })
      }
      {...props}
    />
  )
}
